import { FullLoader } from '@openx/components/core';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { getEnvironmentConfigs } from '../../../environmentConfigs';
import { hasSessionId } from '../utils/verifyOAuthParams';

export const Main = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { unityOrigin } = getEnvironmentConfigs();

  useEffect(() => {
    if (hasSessionId(location)) {
      navigate('/login');
    } else if (unityOrigin) {
      window.location.href = unityOrigin;
    }
  }, [location, navigate, unityOrigin]);

  return <FullLoader />;
};
